import { useState } from 'react';
import { usePostHog } from 'posthog-js/react';
import {
  Form,
  Button,
  TextFieldControlled as Input,
  SelectFieldNativeControlled as Select,
} from '@leafwell/components';
import { useWordPressContext } from 'contexts/wordpress-provider';
import { useBrazeContext } from 'contexts/braze-context';
import { useEventsTracker } from 'contexts/eventsTracker';
import { useStatesList } from 'hooks/useStatesList';

export default function JoinStudyForm() {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const posthog = usePostHog();
  const { trackEvent } = useEventsTracker();
  const { saveUser: saveBrazeUser } = useBrazeContext();
  const { translations } = useWordPressContext();
  const statesList = useStatesList();

  async function handleSubmit({
    name,
    email,
    phone,
    state,
    dateOfBirth,
    message,
  }) {
    // https://posthog.com/docs/product-analytics/identify#alias-assigning-multiple-distinct-ids-to-the-same-user
    posthog.alias(email);

    saveBrazeUser({
      name,
      email,
      phone,
      customAttributes: {
        state: translations[state.toUpperCase()],
      },
    });

    trackEvent({
      event: 'form_submit',
      form_name: `formType_${window?.location?.pathname}`,
      form_destination: window?.location?.pathname,
      form_submit_text: translations['Apply Now'],
      formType: 'join_patient_study_form',
      dateOfBirth,
      message,
    });

    setFormSubmitted(true);
  }

  return (
    <Form
      className="gap-y-4"
      mode="onSubmit"
      defaultValues={{
        name: '',
        email: '',
        phone: '',
        dateOfBirth: '',
        state: '',
        message: '',
      }}
      onSubmit={handleSubmit}
    >
      {formSubmitted ? (
        <p className="text-center">
          Thanks for applying to take part in our patient study.
          <br />
          Check your inbox for a confirmation email.
        </p>
      ) : (
        <>
          <Input
            className="rounded-lg"
            type="text"
            name="Name"
            placeholder={`${translations['Name']} *`}
            validations={['required']}
          />
          <Input
            className="rounded-lg"
            type="email"
            name="email"
            placeholder={`${translations['Email']} *`}
            validations={['required', 'email']}
          />
          <Input
            className="rounded-lg"
            type="tel"
            name="phone"
            placeholder="Phone (optional)"
          />
          <Input
            className="rounded-lg"
            type="date"
            name="dateOfBirth"
            placeholder="Date of birth (optional)"
          />
          <Select
            aria-label="Select your state"
            name="state"
            placeholder={`${translations['State']} (optional)`}
            options={statesList}
            className="rounded-lg"
          />
          <Input
            className="rounded-lg"
            type="textarea"
            name="message"
            placeholder="Reason for MMJ (optional)"
          />
          <Button
            type="submit"
            label={translations['Apply Now']}
            name="submit"
            variant="secondary"
            className="w-full rounded-lg"
          />
        </>
      )}
    </Form>
  );
}
